import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Grid, IconButton, Typography } from '@mui/material';
import { useLayoutEffect, useRef } from 'react';
import { useBanner } from './BannerStateProvider';

const Banner = ({ onClick, bannerText }: { onClick: () => void; bannerText: string }) => (
  <>
    <ErrorOutlineRoundedIcon {...{ sx: { ml: 2 } }} />
    <Typography {...{ fontSize: 14, flexGrow: 1, my: '13.5px' }}>{bannerText}</Typography>

    <IconButton {...{ onClick, sx: { color: 'black', mr: 1 } }}>
      <CloseRoundedIcon {...{ sx: { ml: 'auto' } }} />
    </IconButton>
  </>
);

const bannerContainerStyle = {
  minHeight: '48px',
  color: 'black',

  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  gap: 1,
  flexDirection: 'row',
  alignItems: 'center',
};

export const BannerForPage = () => {
  const { bannerShown, resetBanner, bannerText, setBannerHeight } = useBanner();
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) {
      setBannerHeight(0);
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      setBannerHeight(entry.contentRect.height);
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
      setBannerHeight(0);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerShown]);

  return bannerShown ? (
    <Grid
      container
      item
      {...{
        ref,
        sx: {
          ...bannerContainerStyle,
          backgroundColor: '#FFFFFF',
          boxShadow: '0px 2px 12px rgba(63, 108, 150, 0.24)',
          position: 'relative',
          zIndex: 1300,
        },
      }}>
      <Banner {...{ onClick: resetBanner, bannerText }} />
    </Grid>
  ) : null;
};
